import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import AuthTenantPageError from '../error/AuthTenantPageError';
import AuthTenantLoader from '../loaders/AuthTenantLoader';
import { tenant_auth_actions_helper } from '../../actions/actions_helper';
import { ADMIN_RETRIEVE_SPECIFIC_TENANT_MODULE_LIST_API } from '../../api/api_data';
import { fail_retrieve_tenant_modules, loading_retrieve_tenant_modules, reset_retrieve_tenant_modules, success_retrieve_tenant_modules } from '../../reducers/auth_tenant/retrieve_tenant_modules_Slice';
import * as app_consts from "../../utils/app_consts";
import { RETRIEVE_TENANT_MODULES_ERROR_MSG, RETRIEVE_TENANT_MODULES_SUCCESS_MSG } from '../../utils/error_success_messages';
import { formatNumber, formatToSentenceCase, messageToast } from '../../utils/Utils';
import { useSelector } from 'react-redux';
import { Block, BlockBetween, BlockHead, BlockHeadContent, DataTableHead, DataTableItem, DataTableRow, Icon, PaginationComponent } from '../../components/Component';
import AuthTenantNoData from '../error/AuthTenantNoData';
import { Badge, Button } from 'reactstrap';
import AdminAddModuleToTenantModal from '../../components/modal/data/admin/AdminAddModuleToTenantModal';
import moment from 'moment';
import AdminViewTenantPromotionsDashboard from '../../components/modal/data/admin/AdminViewTenantPromotionsDashboard';

const AdminTenantModules = ({ tenant_info, user_info, tenant_id, successFunction }) => {

  const [page_data, setPageData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const { id } = useParams();
  const dispatch = useDispatch();
  const [sm, updateSm] = useState(false);
  const [add_module_to_tenant_modal, setAddModuleToTenantModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(10);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const [view_promotions_dashboard, setViewPromotionsDashboard] = useState(false);
  const [selected_details, setSelectedDetails] = useState('');


  const open_add_module_to_tenant_modal = () => {
    setAddModuleToTenantModal(true);
  };

  const close_add_module_to_tenant_modal = () => {
    setAddModuleToTenantModal(false);
  };

  const add_module_to_tenant_modal_successFunction = () => {
    close_add_module_to_tenant_modal();
    successFunction();
  };

  useEffect(() => {
    retrieve_data();
  }, []);

  const retrieve_data = () => {
    setError("");
    dispatch(tenant_auth_actions_helper(loading_retrieve_tenant_modules, success_retrieve_tenant_modules, fail_retrieve_tenant_modules, RETRIEVE_TENANT_MODULES_ERROR_MSG, RETRIEVE_TENANT_MODULES_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${ADMIN_RETRIEVE_SPECIFIC_TENANT_MODULE_LIST_API}/${id}`));
  };

  // Listener
  const retrieve_tenant_modules_listener = useSelector((state) => state.retrieve_tenant_modules.retrieve_tenant_modules);

  useEffect(() => {
    if (retrieve_tenant_modules_listener.status !== app_consts.IDLE)
    {
      if (retrieve_tenant_modules_listener.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        if (retrieve_tenant_modules_listener.status === app_consts.FAIL)
        {
          setLoading(false);
          setError(retrieve_tenant_modules_listener.message);
          messageToast(retrieve_tenant_modules_listener.message, app_consts.FAIL);
        } else if (retrieve_tenant_modules_listener.status === app_consts.SUCCESS)
        {
          setPageData(retrieve_tenant_modules_listener.data);
          const timer = setTimeout(() => {
            setLoading(false);
          }, 1000);

          return () => clearTimeout(timer); // cleanup in case the component unmounts
        }
        dispatch(reset_retrieve_tenant_modules());
      }
    }
  }, [retrieve_tenant_modules_listener]);

  // Get current list, pagination
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = page_data?.slice(indexOfFirstItem, indexOfLastItem);

  const open_dashboard = (item) => {
    setSelectedDetails(item);
    if (item?.tenant_module?.module_name === app_consts.PROMOTIONS)
    {
      open_view_promotions_dashboard();
    }
  };

  const open_view_promotions_dashboard = () => {
    setViewPromotionsDashboard(true);
  };

  const close_view_promotions_dashboard = () => {
    setSelectedDetails('');
    setViewPromotionsDashboard(false);
  };

  const view_promotions_dashboard_successFunction = () => {
    retrieve_data(id);
  };



  return (
    <>
      {
        loading ?
          <>
            <AuthTenantLoader tenant_info={tenant_info} loading_message="Loading Tenant Module Details..." />
          </>
          :
          <>
            {
              error ?
                <>
                  <AuthTenantPageError tenant_info={tenant_info} error_message={error} />
                </>
                :
                <>
                  <BlockHead size="sm">
                    <BlockBetween>
                      {!(loading || error) && (
                        <BlockHeadContent>
                          <div className="toggle-wrap nk-block-tools-toggle">
                            <a
                              href="#more"
                              className="btn btn-icon btn-trigger toggle-expand me-n1"
                              onClick={(ev) => {
                                ev.preventDefault();
                                updateSm(!sm);
                              }}
                            >
                              <Icon name="more-v"></Icon>
                            </a>
                            <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                              <ul className="nk-block-tools g-3">
                                {(user_info?.roles?.includes(app_consts.ADD_TENANT_MODULE) || user_info?.roles?.includes(app_consts.ADMINISTRATOR)) && (
                                  <li className="nk-block-tools-opt">
                                    <Button
                                      className="toggle d-none d-md-inline-flex"
                                      color="primary"
                                      onClick={open_add_module_to_tenant_modal}
                                    >
                                      <Icon name="plus"></Icon>
                                      <span>Add Tenant Module</span>
                                    </Button>
                                  </li>
                                )}
                              </ul>
                            </div>
                          </div>
                        </BlockHeadContent>
                      )}
                    </BlockBetween>
                  </BlockHead>
                  {
                    page_data && page_data?.length > 0 ?
                      <>
                        <Block>
                          <div className="nk-tb-list is-separate is-medium mb-3">
                            <DataTableHead className="nk-tb-item">
                              <DataTableRow>
                                <span className="sub-text">Module Name</span>
                              </DataTableRow>
                              <DataTableRow>
                                <span className="sub-text">Tenant</span>
                              </DataTableRow>
                              <DataTableRow>
                                <span className="sub-text">Created On</span>
                              </DataTableRow>
                              <DataTableRow>
                                <span className="sub-text">No of Employees</span>
                              </DataTableRow>
                              <DataTableRow>
                                <span className="sub-text">Action</span>
                              </DataTableRow>
                            </DataTableHead>
                            {currentItems.length > 0
                              ? currentItems.map((item) => (
                                <DataTableItem key={item?.tenant_module?.id}>
                                  <DataTableRow>
                                    <div className="user-card">
                                      <div className="user-info">
                                        <span className="tb-lead">
                                          {item?.tenant_module?.module_name?.replace(/_/g, ' ').toUpperCase() || "--"}<span className="dot dot-success d-md-none ms-1"></span>
                                        </span>
                                      </div>
                                    </div>
                                  </DataTableRow>
                                  <DataTableRow>
                                    <div className="user-card">
                                      <div className="user-info">
                                        <span className="tb-lead">
                                          {item?.tenant?.name || "--"}<span className="dot dot-success d-md-none ms-1"></span>
                                        </span>
                                      </div>
                                    </div>
                                  </DataTableRow>
                                  <DataTableRow size="md">
                                    <div className="user-info">
                                      <span className="tb-lead">{item?.tenant_module?.inserted_at ? moment(item?.tenant_module?.inserted_at).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                    </div>
                                  </DataTableRow>
                                  <DataTableRow>
                                    <div className="user-card">
                                      <div className="user-info">
                                        <span>{item?.tenant_module?.employee_count ? item?.tenant_module?.employee_count : "0"}</span>
                                      </div>
                                    </div>
                                  </DataTableRow>
                                  <DataTableRow className="nk-tb-col-tools">
                                    <div className="tb-odr-btns d-none d-sm-inline">
                                      <Button color="primary" size="sm" className="btn btn-dim" onClick={() => open_dashboard(item)}>
                                        View Dashboard
                                      </Button>
                                    </div>
                                    <Button className="btn-pd-auto d-sm-none">
                                      <Icon name="chevron-right"></Icon>
                                    </Button>
                                  </DataTableRow>
                                </DataTableItem>
                              ))
                              : null}
                          </div>
                          {currentItems.length > 0 && (
                            <div className="mt-3">
                              <PaginationComponent
                                itemPerPage={itemPerPage}
                                totalItems={page_data?.length}
                                paginate={paginate}
                                currentPage={currentPage}
                              />
                            </div>
                          )}
                        </Block>
                      </>
                      :
                      <>
                        <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Tenant Modules Found"} />
                      </>
                  }

                  <AdminAddModuleToTenantModal tenant_info={tenant_info} user_info={user_info} isOpen={add_module_to_tenant_modal} successFunction={add_module_to_tenant_modal_successFunction} closeModal={close_add_module_to_tenant_modal} tenant_id={tenant_id} />

                  <AdminViewTenantPromotionsDashboard isOpen={view_promotions_dashboard} closeModal={close_view_promotions_dashboard} successFunction={view_promotions_dashboard_successFunction} data={selected_details} tenant_info={tenant_info} user_info={user_info} />
                </>
            }
          </>
      }
    </>
  );
};

export default AdminTenantModules;